module.exports = __webpack_public_path__ + "static/media/SDFSA_5-509w.e7ea0af5.jpg";